import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ItemSliding } from 'ionic-angular';

import { ContactsAddPage } from '../contacts-add/contacts-add';

import { DatabaseProvider } from '../../providers/database/database';
import { ContactItem } from './contactitem';

import { CallNumber } from '@ionic-native/call-number';


@IonicPage()
@Component({
  selector: 'page-contacts',
  templateUrl: 'contacts.html',
})
export class ContactsPage {

  constructor(public navCtrl: NavController, public navParams: NavParams,
                public dbProvider: DatabaseProvider, private aCallNumber: CallNumber) {
      
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ContactsPage');
  }

  addContact(){
    console.log('addContact() called...');
    this.navCtrl.push(ContactsAddPage, {});
  }

  editContact(slidingItem: ItemSliding, aContactItem: ContactItem){
    //this.tasks.update(aContactItem.$key, {status: 'done'});
    slidingItem.close();
  }

  removeContact(slidingItem: ItemSliding, aContactItem: ContactItem){
    this.dbProvider.removeContact(aContactItem);
    slidingItem.close();
  }

  callContact(aContactItem: ContactItem){
    this.aCallNumber.callNumber(aContactItem.tel1, true)
    .then(() => console.log('Launched dialer!'))
    .catch(() => console.log('Error launching dialer'));
  }
  
}




// WEBPACK FOOTER //
// ./src/pages/contacts/contacts.ts